<template>
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" :style="`transform: rotate(-90deg)`">
    <path d="M1 3L5 7L9 3" :stroke="disabled ? '#DFE2EB' : '#727D94'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: true
        }
    }
}
</script>
